import React from 'react';
import { Row, Col, Radio, Slider, Button, Checkbox } from 'antd';
import { RegionSelectionConstants } from "../../actionTypes/region_selection.constant"
import ReactRegionSelect from 'react-region-select';
import { scanSpeed, specimenType, objectiveType, scanOutputFormat } from "./slots"

export const getBrushPanel = (usingBrush, brushSize, onBrushToolChange, onBrushSizeChange) => {
    return [
        <Row key={0} style={{ padding: 10 }}>
            <Radio.Group defaultValue={usingBrush} buttonStyle="solid" onChange={onBrushToolChange}>
                <Radio.Button value={true}>Brush</Radio.Button>
                <Radio.Button value={false}>Eraser</Radio.Button>
            </Radio.Group>
        </Row>,
        <Row key={1}>
            <Col span={4} offset={10}>
                <Slider defaultValue={brushSize} onChange={onBrushSizeChange} max={50} min={1}/>
            </Col>
        </Row>
    ]
}

export const getSpeedPanel = (onScanSpeedChange, preview) => {
    return [
        <Row key={0} style={{ padding: 10 }}>
            <Row style={{fontSize:13}}>Set Scan Speed</Row> 
            <Radio.Group defaultValue={scanSpeed.FAST} value={preview.speed} buttonStyle="solid" onChange={onScanSpeedChange}>
                <Radio.Button value={scanSpeed.FAST}>Fast</Radio.Button>
                <Radio.Button value={scanSpeed.MEDIUM}>Medium</Radio.Button>
                <Radio.Button value={scanSpeed.SLOW}>Slow</Radio.Button>
            </Radio.Group>
        </Row>
    ]
}

export const getButtonsPanel = (status, onConfirm, onRetakePreview, clearSelection, selectFullRegion, numSelectedRegions, loaderCapacity) => {
    let confirmButton = null;
    let showConfirm = loaderCapacity > 1 || status !== RegionSelectionConstants.SELECTION_DONE ? true : false;
    if (showConfirm) {
        confirmButton = [<Col span={2} key={0}>
                            <Row key={0} style={{ paddingTop: 10 }}>
                                <Button
                                    disabled={numSelectedRegions <= 0}
                                    type="primary"
                                    shape="circle"
                                    icon="check"
                                    onClick={onConfirm} />
                            </Row>
                            <Row key={1} style={{ fontSize: 13 }}>Click to Confirm</Row>
                        </Col>];
    }
    
    let colOffset = showConfirm ? 8 : 9;

    return <Row key={0}>
        <Col span={2} offset={colOffset}>
            <Row key={0} style={{ paddingTop: 10 }}>
                <Button
                    type="default"
                    shape="circle"
                    icon="undo"
                    onClick={onRetakePreview} />
            </Row>
            <Row key={1} style={{ fontSize: 13 }}>Retake Preview</Row>
        </Col>
        {confirmButton}
        <Col span={2}>
            <Row key={0} style={{ paddingTop: 10 }}>
                <Button
                    disabled={status !== RegionSelectionConstants.SELECTION_DONE}
                    type="danger"
                    shape="circle"
                    icon="arrow-left"
                    onClick={clearSelection} />
            </Row>
            <Row key={1} style={{ fontSize: 13 }}>Clear Selection</Row>
        </Col>
        <Col span={2}>
            <Row key={0} style={{ paddingTop: 10 }}>
                <Button
                    disabled={status === RegionSelectionConstants.SELECTION_DONE}
                    type="default"
                    shape="circle"
                    icon="border"
                    onClick={selectFullRegion} />
            </Row>
            <Row key={1} style={{ fontSize: 13 }}>Full Scan</Row>
        </Col>
    </Row>
}

export const getConfirmedPanel = (clearSelection) => {
    return [
        <Row key={0} style={{ fontSize: 18 }}>
            Selection Confirmed.
        </Row>,
        <Row key={1}>
            <Col>
                <Row key={0} style={{ paddingTop: 10 }}>
                    <Button
                        type="danger"
                        shape="circle"
                        icon="redo"
                        onClick={clearSelection} />
                </Row>
                <Row key={1} style={{ fontSize: 13 }}>Click to Redo</Row>
            </Col>
        </Row>
    ]
}

export const getAdminPanel = (preview, toggleTiling) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row style={{fontSize:13}}><Checkbox checked={preview.doTilingOnly} onChange={toggleTiling}>Do Tiling Only</Checkbox></Row>
        </Col>
    </Row>
}

export const getSpecimenChooser = (onSpecimenTypeChange, preview, isSuperuser) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{ padding: 10 }}>
                <Row style={{fontSize:13}}>Set Specimen Type</Row> 
                <Radio.Group defaultValue={specimenType.HNE_TISSUE} value={preview.specimenType} buttonStyle="solid" onChange={onSpecimenTypeChange}>
                    <Radio.Button value={specimenType.HNE_TISSUE}>HNE</Radio.Button>
                    <Radio.Button value={specimenType.BLOOD}>Blood</Radio.Button>
                    <Radio.Button value={specimenType.LBC}>Pap</Radio.Button>
                    <Radio.Button value={specimenType.IHC}>IHC</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getObjectiveChooser = (onObjectiveTypeChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{ padding: 10 }}>
                <Row style={{fontSize:13}}>Set Objective Type</Row> 
                <Radio.Group defaultValue={objectiveType.FORTY_X} value={preview.objectiveType} buttonStyle="solid" onChange={onObjectiveTypeChange}>
                    <Radio.Button value={objectiveType.FORTY_X}>40X</Radio.Button>
                    <Radio.Button value={objectiveType.TWENTY_X}>20X</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getScanOutputFormatChanger = (onScanOutputFormatChange, preview) => {
    return <Row>
        <Col span={24}>
            <br></br>
            <Row key={0} style={{ padding: 10 }}>
                <Row style={{fontSize:13}}>Choose Scan Format</Row> 
                <Radio.Group defaultValue={scanOutputFormat.JPG} value={preview.scanOutputFormat} buttonStyle="solid" onChange={onScanOutputFormatChange}>
                    <Radio.Button value={scanOutputFormat.JPG}>JPG</Radio.Button>
                    <Radio.Button value={scanOutputFormat.PNG}>PNG</Radio.Button>
                </Radio.Group>
            </Row>
        </Col>
    </Row>
}

export const getCanvasComponent = (status, previewCanvasRef, thresholdCanvasRef, regions, onCanvasChange, allowPainting, startPainting, paintCanvas, stopPainting) => {

    const regionStyle = {
        background: 'rgba(255, 0, 0, 0)',
        zIndex: 1
    };

    return <Col style={{ alignItems: "center" }} span={16}>
        {status === RegionSelectionConstants.FETCHED_IMAGE ?
            <ReactRegionSelect
                style={{ zIndex: 1 }}
                maxRegions={1}
                regions={regions}
                regionStyle={regionStyle}
                constraint
                onChange={onCanvasChange}>
                <div className="preview-canvas-wrapper">
                    <canvas ref={previewCanvasRef} className="region-selection-canvas" />
                    <canvas ref={thresholdCanvasRef} className="region-selection-canvas" />
                </div>
            </ReactRegionSelect> :
            <div style={{ zIndex: 1, marginBottom: "8px" }} className="preview-canvas-wrapper">
                <canvas ref={previewCanvasRef} className="region-selection-canvas" />
                <canvas id="thresholdCanvas"
                    onMouseDown={allowPainting ? startPainting : undefined}
                    onMouseMove={allowPainting ? paintCanvas : undefined}
                    onMouseUp={allowPainting ? stopPainting : undefined}
                    ref={thresholdCanvasRef}
                    className="region-selection-canvas" />
            </div>
        }
    </Col>
}

export const createThresholdedCanvas = (thresholdCanvas, thresholdedPath, regions) => {
    const thresholdContext = thresholdCanvas.getContext('2d');
    const thresholdImage = new Image();
    thresholdImage.src = "/scan-ssd/" + thresholdedPath;
    thresholdImage.onload = () => {
        thresholdContext.clearRect(0, 0, thresholdCanvas.width, thresholdCanvas.height);
        thresholdContext.drawImage(thresholdImage, 0, 0, thresholdCanvas.width, thresholdCanvas.height);
        cleanUpExtra(thresholdCanvas, thresholdContext, regions);
    }
    thresholdContext.globalAlpha = 0.5;
}

export const cleanUpExtra = (thresholdCanvas, thresholdContext, regions) => {
    let reg = regions[0];
    let x1 = parseInt((reg.x * thresholdCanvas.width) / 100.0);
    let x2 = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
    let y1 = parseInt((reg.y * thresholdCanvas.height) / 100.0);
    let y2 = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
    thresholdContext.clearRect(0, 0, x1, thresholdCanvas.height);
    thresholdContext.clearRect(x1, 0, thresholdCanvas.width - x1, y1);
    thresholdContext.clearRect(x2, y1, thresholdCanvas.width - x2, thresholdCanvas.height - y1);
    thresholdContext.clearRect(x1, y2, x2 - x1, thresholdCanvas.height - y2);
    thresholdContext.fillStyle = "#000000";
    thresholdContext.fillRect(0, 0, x1, thresholdCanvas.height);
    thresholdContext.fillRect(x1, 0, thresholdCanvas.width - x1, y1);
    thresholdContext.fillRect(x2, y1, thresholdCanvas.width - x2, thresholdCanvas.height - y1);
    thresholdContext.fillRect(x1, y2, x2 - x1, thresholdCanvas.height - y2);
    thresholdContext.beginPath();
    let strokeSize = 2;
    thresholdContext.lineWidth = 2 * strokeSize;
    thresholdContext.strokeStyle = "green";
    thresholdContext.rect(Math.max(0, x1 - strokeSize), Math.max(0, y1 - strokeSize), x2-x1 + 2 * strokeSize, y2-y1 + 2 * strokeSize);
    thresholdContext.stroke();
}

export const updateImages = (previewCanvas, previewPath, thresholdCanvas, thresholdedPath, regions) => {

    const previewContext = previewCanvas.getContext('2d');
    previewContext.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
    const previewImage = new Image();
    previewImage.src = "/scan-ssd/" + previewPath;
    previewImage.onload = () => {
        previewContext.drawImage(previewImage, 0, 0, previewCanvas.width, previewCanvas.height);
    }

    if (regions.length > 0) {
        createThresholdedCanvas(thresholdCanvas, thresholdedPath, regions);
    }
}